import {mapGetters} from 'vuex';

export default {
    name: 'marketTrendsBreadcrumb',
    props: {
        breadCrumb: {
            type: Array,
            default: []
          },
        isLink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getBreadCrumbData() {
            return this.breadCrumb;
        }
    }
};
